import { render, staticRenderFns } from "./Wp_jd_my.vue?vue&type=template&id=03603a1c&scoped=true&"
import script from "./Wp_jd_my.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_my.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_my.vue?vue&type=style&index=0&id=03603a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03603a1c",
  null
  
)

export default component.exports